import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ExpandCollapseButton from "./expandCollapseButton";
import TakeOverButton from "./takeOverButton";
import ReviewEntryButton from "./reviewEntry";
import FileEntryButton from "./fileEntry";
import StartJobButton from "./startJobButton";
import UpdateEntry from "./updateEntry";
import UpdateResponseEntry from "./updateResponseEntry";
import CancelEntryModal from "./cancelEntry";
import { Button } from "semantic-ui-react";
import { get } from "lodash";
import Dv1Generation from "../../components/ES_App/formSections/dv1Generation";
// import { getRequestIdByShipmentId } from "../../commonApis";
// import { showToast } from "../../components/commonComponents/showToast";
import BackToPoolButton from "./backToPoolButton";
import { getJobWheels } from "../../components/util";
import { selectCancelReasonList } from "@EUForms/selectors";
import { Portal } from '../../components/commonComponents/portal';
import CertDropdown from "./certDropdown";

function ButtonMapper(props) {
  //const dispatch = useDispatch()
  const cancelReasonList = useSelector(selectCancelReasonList);
  useEffect(() => {
    setTimeout(() => {
      buildButtons()
    }, 5000);

    return () => {

    }
  }, [JSON.stringify(props.currentJobData), props.shipId])

  const [reviewedSuccessfully, setReviewSuccessfully] = useState(false);
  const [fileWithGateway, setFileWithGateway] = useState('1');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    //dispatch(resetServerErrors());
    setReviewSuccessfully(false)
  }, [props.shipId])

  const setReviewedSuccess = () => {
    setReviewSuccessfully(true)
  }
  //console.log("props:", props)

  const buildButtons = () => {
    let jobWheels = getJobWheels(props.currentJobData);
    const EntryState = jobWheels["ES_ENTRY_JOB_WHEEL"]?.value?.state || ""
    const ESCustomState = jobWheels["ES_CUSTOM_JOB_WHEEL"]?.value?.state || ""
    const bhHouse = jobWheels["SHIPMENT_BROKER_HOUSE_PROCESS"]?.value?.state || ""
    const isEntryNewJob = EntryState.includes('NONE');
    const isEntryEditable = EntryState.includes('IN_PROCESS') || EntryState.includes('READY');
    const isEntryInProcess = EntryState.includes('STATE_ENTRY_IN_PROCESS');
    const isEntryFileReady = EntryState.includes('READY');
    const isEntryFiled = EntryState === 'STATE_ENTRY_FILED';
    const isEntryRejected = EntryState === 'STATE_ENTRY_REJECTED';
    const isEntryAccepted = EntryState === 'STATE_ENTRY_ACCEPTED';
    const isEntryAmendInProcess = EntryState.includes('STATE_ENTRY_AMEND_IN_PROCESS');
    const isEntryAmendFileReady = EntryState.includes('STATE_ENTRY_AMEND_READY');
    const isEntryAmendFiled = EntryState === 'STATE_ENTRY_AMEND_FILED';
    const isCancelledFiled = EntryState === 'STATE_ENTRY_CANCELLED_FILED';
    const isCancelAccepted = EntryState === 'STATE_ENTRY_CANCELLED';
    const isCancelledFailed = EntryState === 'STATE_ENTRY_CANCELLED_FAILED';
    const isEntryAmendRejected = EntryState === 'STATE_ENTRY_AMEND_REJECTED';
    const isEntryAmendAccepted = EntryState === 'STATE_ENTRY_AMEND_ACCEPTED';
    const dv1FormVisiblity = ['STATE_RELEASED', 'STATE_CLEAR'].includes(ESCustomState)
    const isShipmentRejected = ESCustomState.includes("FAILED");
    const userGuid = get(props, "kxUser.userBasicInfo.userGuid");
    const brokerGuid = get(props, "currentJobData.brokerGuid");
    const isBox40req = ESCustomState.includes("BOX_40_REQUIRED");
    const isBox44req = ESCustomState.includes("BOX_44_REQUIRED");
    const brokerEmail = get(props, "kxUser.userBasicInfo.email");
    const declarationEntryType = get(props, "EUData.declarationEntryType");
    const transmissionType = get(props, "EUData.transmissionType");
    const START_JOB = get(props, "EUData.START_JOB", false);
    let formType = "";

    const formTypeMap = {
      "PDC_AMEND": "PdcAmend",
      "PDC": "PDC",
      "PDI_AMEND": "PdiAmend",
      "PDI": "PDI",
      "PDS": "PDS",
      "FULL_SAD": "FullSad",
      "BOX_40": "Box40",
      "BOX_44": "Box44",
      "CANCEL": "Cancel",
      "TYPE_A_AMEND": "ExportAmendTypeA",
      "TYPE_B_AMEND": "ExportAmendTypeB",
      "TYPE_C_AMEND": "ExportAmendTypeC",
      "TYPE_D_AMEND": "ExportAmendTypeD",
      "TYPE_A": "ExportTypeA",
      "TYPE_B": "ExportTypeB",
      "TYPE_CER": "ExportTypeCer",
      "TYPE_C": "ExportTypeC",
      "TYPE_DOC": "ExportTypeDoc",
      "TYPE_D": "ExportTypeD",
      "TYPE_PRE": "ExportTypePre",
      "TYPE_X": "ExportTypeX",
      "TYPE_Y": "ExportTypeY",
      "TYPE_NOT": "ExportTypeNot"
    };

    for (const key in formTypeMap) {
      if (ESCustomState.includes(key)) {
        formType = formTypeMap[key];
        break;
      }
    }


    let listOfButtons = []

    if (((bhHouse === 'STATE_BH_ASSIGNED' || bhHouse === 'STATE_BH_BROKER_ASSIGNED')
      || (bhHouse === 'STATE_BH_BROKER_IN_PROCESS' && userGuid !== brokerGuid)) && isEntryEditable) {
      let takeOverLabel = (bhHouse === 'STATE_BH_ASSIGNED' || bhHouse === 'STATE_BH_BROKER_ASSIGNED') ? "START_OVER" : "TAKE_OVER"
      listOfButtons.push(
        <TakeOverButton
          {...props}
          label={takeOverLabel}
          translate={props.translate}
          currentEntryState={EntryState}
          ESCustomState={ESCustomState} />);
      return listOfButtons;
    }


    if ((bhHouse === 'STATE_BH_ASSIGNED' || bhHouse === 'STATE_BH_BROKER_ASSIGNED') || START_JOB) {
      listOfButtons.push(
        <StartJobButton
          {...props}
          EntryState={EntryState}
          ESCustomState={ESCustomState}
          display={'none'}
        />
      );
      return listOfButtons;
    }

    if (dv1FormVisiblity && userGuid == brokerGuid && props.serviceType === 'IMPORT') {
      console.log(props.serviceType)
      listOfButtons.push(<Dv1Generation />)
      return listOfButtons
    }
    if (userGuid === brokerGuid && (isEntryInProcess || isEntryFileReady)) {
      listOfButtons.push(
        <BackToPoolButton {...props} />
      );
    }
    if (isEntryEditable && !reviewedSuccessfully && formType) {
      listOfButtons.push(
        <ReviewEntryButton
          setReviewSuccessfully={setReviewedSuccess}
          currentEntryState={EntryState}
          {...props}
          formType={formType}
        //getValidationNctsErrorMessage={props.getValidationNctsErrorMessage} 
        />
      );
    }
    //CORE-15925
    if (brokerEmail !== "luis.miguel-silva.2@klearnow.com" && isEntryFileReady && reviewedSuccessfully) {
      listOfButtons.push(
        <FileEntryButton
          {...props}
          formType={formType}
        />
      );
    }
    if ((!isEntryEditable && isEntryRejected) ||
      (isEntryAccepted && isBox40req) ||
      (isEntryAccepted && isBox44req) ||
      isEntryAmendRejected ||
      isEntryAmendAccepted) {
      listOfButtons.push(
        <UpdateEntry
          {...props}
          EntryState={EntryState}
        />
      );
    }
    if (isCancelledFailed) {
      listOfButtons.push(
        <CancelEntryModal
          key='cancelship'
          shipmentId={window.shipmentId}
          fileWithGateway={true}
          showModal={showModal}
          setShowModal={setShowModal}
          cancelReason={""}
          language='es'
          countryCode='ES'
          serviceType={props.serviceType}
          version={props.version}
          cancelReasonList={cancelReasonList || null}
          trigger={
            <Button
              size="mini"
              id="cancelShipment"
              key="CANCEL_ES"
              disabled={false}
              className="sv todo-button primaryBtn"
              onClick={() => {
                setShowModal(true)
              }}
            >
              {"CANCEL"}
            </Button>
          }
          lowerEnv={props?.lowerEnv}
          searchByID={props.searchByID}
        />)
    }
    if (isEntryFiled || isEntryAmendFiled || isCancelledFiled) {

      listOfButtons.push(
        <>
          {
            props.serviceType === "IMPORT" &&
            <Button
              size="mini"
              key="XMLSENT"
              disabled={false}
              className="sv todo-button secondaryBtn"
              onClick={() => {
                window.open(`broker-panel/xml-sent/es/${props.shipId}`, '_blank')
              }}
            >
              VIEW XML SENT
            </Button>
          }
          {
            // props.version !== "AES" &&
            <UpdateResponseEntry
              propMRN={props.currentJobData.mrn}
              formType={formType}
              shipmentId={props.currentJobData.shipmentId}
              ESCustomState={ESCustomState}
              serviceType={props.serviceType}
              buttonTitle={"UPDATE RESPONSE"}
              version={props.version}
            />
          }
        </>
      )
    }
    if (isCancelAccepted) {
      listOfButtons.push(
        <div style={{ fontSize: '13px', color: 'crimson' }}>
          <strong>Note: </strong>No Action can be performed after Cancellation
          Accepted.
        </div>)
    }
    return listOfButtons
  }


  let workflowButtons = buildButtons() || []
 return (
    <div className="ace header-container dv-todo-isfheader">
      <ExpandCollapseButton {...props} />
      <>
       
        {
          window.typeOfUser !== "BROKER_KN_ADMIN" && workflowButtons.map((buttonItem, idx) => {
            // console.log("buttonitem:", buttonItem)
            return <React.Fragment key={idx + "-workflow-btn"}>{buttonItem}</React.Fragment>
          })
        }
      </>
    </div>
  );
}

export default ButtonMapper;